import { render } from "./ClassReport.vue?vue&type=template&id=bf5ead44&scoped=true"
import script from "./ClassReport.vue?vue&type=script&lang=js"
export * from "./ClassReport.vue?vue&type=script&lang=js"

import "./ClassReport.vue?vue&type=style&index=0&id=bf5ead44&scoped=true&lang=css"

import exportComponent from "/var/www/html/dongan_teens2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf5ead44"]])

export default __exports__